import { useLocation } from 'react-router-dom';

export const useQueryParams = (): Record<string, string> => {
    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlSearchParams.entries());

    return params;
};
